module.exports = __webpack_public_path__ + "img/logoEifoanyWhite.029dc977.png";